import Home from './components/pages/Home';
import Projects from './components/pages/Projects';
import { Particle } from './components/Particles/Particle';
import './index.scss';
import Header from './components/Header/Header';
import { Routes, Route } from 'react-router-dom';
import Lang from './components/Lang/Lang';

export type worksArrProps = {
  title: string;
  img: string;
  link: string;
  tech: string[];
}[];

export const portfolioWorks: worksArrProps = [
  // prettier-ignore
  { title: 'Empress Academy', img: 'empress', link: 'https://agentdmitro.github.io/Empress-Academy/', tech: ['HTML', 'SCSS', 'JS / JQ', 'WP']},
  {
    title: 'RitmStyle',
    img: 'ritm',
    link: 'https://agentdmitro.github.io/RitmStyle/',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'Mafia',
    img: 'mafia',
    link: 'https://agentdmitro.github.io/mafia',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'PC course',
    img: 'course',
    link: 'https://agentdmitro.github.io/Course/',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'IT-Meteor',
    img: 'meteor',
    link: 'https://it-meteor.ru/',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'skinTrade',
    img: 'skintrade',
    link: 'https://agentdmitro.github.io/SkinTrade/',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'Gravity',
    img: 'gravity',
    link: 'https://agentdmitro.github.io/Gravity',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'I-Lights',
    img: 'iLights',
    link: 'https://agentdmitro.github.io/I-Lights',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'instaBot',
    img: 'instaBot',
    link: 'https://agentdmitro.github.io/InstaBOT',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'LaslesVPN',
    img: 'lasles',
    link: 'https://agentdmitro.github.io/LaslesVPN',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'AllBirds',
    img: 'allbirds',
    link: 'https://agentdmitro.github.io/AllBirds',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'Crappo',
    img: 'crappo',
    link: 'https://agentdmitro.github.io/CRAPPO/',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'SushiBox',
    img: 'suchibox',
    link: 'https://agentdmitro.github.io/SuchiBox',

    tech: ['HTML', 'SCSS', 'JS'],
  },
  {
    title: 'Design agency',
    img: 'designAgency',
    link: 'https://agentdmitro.github.io/DesignAgency',

    tech: ['HTML', 'SCSS', 'JS'],
  },
];

function App() {
  return (
    <>
      <Particle />

      <Header />

      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
      </div>

      <Lang />
    </>
  );
}

export default App;
